import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button, Skeleton } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import EmptyState from './EmptyState';
import { getSuggestedKeywords } from 'Explore/Services/Collaborations';
import styles from './EmptyState.module.scss';

const EmptyStateSuggest = ({ entity, filters, setFilters }) => {
  const { data: suggestedKws, isLoading: isSuggestLoading } = useQuery({
    queryKey: ['collab-suggested-kw', entity?.id, entity?.type, filters.yearRange?.[0], filters.yearRange?.[1]],
    queryFn: () => getSuggestedKeywords({
      entity_id: entity?.id,
      entity_type: entity?.type,
      publication_year_start: filters.yearRange?.[0],
      publication_year_end: filters.yearRange?.[1],
    }),
    staleTime: 10 * 60 * 1000,
    enabled: !!entity?.id,
  });

  const handleKeywordClick = (kw) => {
    if (setFilters) {
      setFilters(prev => ({ ...prev, subjectArea: [kw] }));
    }
  };

  return (
    <EmptyState
      icon={<SearchOutlined />}
      title="No collaborations found"
      description="No results matched the selected keywords. Try one of your top research areas:"
    >
      {isSuggestLoading ? (
        <div className={styles.chipWrapper}>
          {[...Array(5)].map((_, i) => <Skeleton.Button key={i} active size="small" shape="round" style={{ width: 100, height: 32 }} />)}
        </div>
      ) : (
        <div className={styles.chipWrapper}>
          {suggestedKws?.keywords?.map((kw) => (
            <div
              key={kw}
              className={styles.suggestChip}
              onClick={() => handleKeywordClick(kw)}
            >
              {kw}
            </div>
          ))}
        </div>
      )}
    </EmptyState>
  );
};

export default EmptyStateSuggest;
